import { useNavigate } from "react-router-dom";
import BoothMark from "./BoothMark";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const go = (path) => (e) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <footer className="booth-shell booth-footer">
      <BoothMark className="booth-footer-mark" />
      <span className="booth-footer-links">
        <a href="/contactus" onClick={go("/contactus")}>Contact</a>
        <a href="/privacyPolicy" onClick={go("/privacyPolicy")}>Privacy</a>
        <a href="/termsOfService" onClick={go("/termsOfService")}>Terms</a>
      </span>
      <span className="booth-footer-copy">© {year} The Booth</span>
    </footer>
  );
}

export default Footer;
